
import store from '../../store'

export const closeNotificationsModal = async (to, from, next)=>
{

  store.dispatch('ui/setShowNotificationsModal',false)
  next()
}
export const roleSystemRoute = async (to, from, next)=>
{
  console.log("roleSystemRoute")
  let accessgranted = await isAccessGranted(to.meta.accessroles)
  if(accessgranted)
  {
    await next();
  }
  else
  {
    next({ name: 'NotFound' })
  }

} 

export const isAccessGranted = async (accessroles)=>{
  let user = store.state.auth.user

  console.log("isAccessGranted")
  console.log(user)
  if(!user)
  {
    return false
  }
  let roles = await store.state.auth.user.userroles
  
  let accessgranted = await true
  if(accessroles && accessroles.length)
  {
    accessgranted = await false
    for(let role of roles)
    {
      if(accessroles.includes(role.name))
      {
        accessgranted = await true
      }
    }
  }

  return await accessgranted
}